import { 
  ScaleIcon, 
  ShieldCheckIcon, 
  BookOpenIcon, 
  GlobeAmericasIcon,
  CurrencyDollarIcon,
  BuildingOfficeIcon,
  TagIcon
} from '@heroicons/react/24/outline'
import { CategoriaNavegacion, TemaNormativo } from '../types/normatividad'

// --- BASE DE DATOS DE CONTENIDOS (FLAT) ---
// Esta base alimenta el buscador y el visor.

export const BASE_NORMATIVA: TemaNormativo[] = [
  // --- LEYES SUPREMAS Y GENERALES ---
  {
    id: 'cpeum',
    titulo: 'Constitución Política de los Estados Unidos Mexicanos',
    descripcion: 'Norma suprema del ordenamiento jurídico mexicano.',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: `
      <div class="prose max-w-none">
        <h3>CONSTITUCIÓN POLÍTICA DE LOS ESTADOS UNIDOS MEXICANOS</h3>
        <p><strong>Artículo 133.</strong> Esta Constitución, las leyes del Congreso de la Unión que emanen de ella y todos los Tratados que estén de acuerdo con la misma, celebrados y que se celebren por el Presidente de la República, con aprobación del Senado, serán la Ley Suprema de toda la Unión.</p>
        <p><strong>Artículo 31 Fracción IV.</strong> Son obligaciones de los mexicanos... contribuir para los gastos públicos...</p>
      </div>
    `
  },
  
  // --- LEYES ADUANERAS Y DE COMERCIO ---
  {
    id: 'ley-aduanera',
    titulo: 'Ley Aduanera',
    descripcion: 'Regula la entrada y salida de mercancías del territorio nacional.',
    tipo: 'LEY',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    indice: [
      { titulo: 'Título Primero: Disposiciones Generales', id_referencia: 'tit-1', nivel: 1 },
      { titulo: 'Título Segundo: Control de la Aduana', id_referencia: 'tit-2', nivel: 1 },
      { titulo: 'Título Tercero: Impuestos al Comercio Exterior', id_referencia: 'tit-3', nivel: 1 }
    ],
    contenido: `
      <div class="prose max-w-none">
        <h3>LEY ADUANERA</h3>
        <p><strong>Nueva Ley publicada en el Diario Oficial de la Federación el 15 de diciembre de 1995</strong></p>
        
        <h4 id="tit-1">TÍTULO PRIMERO - Disposiciones Generales</h4>
        <p><strong>ARTÍCULO 1o.</strong> Esta Ley, las de los Impuestos Generales de Importación y de Exportación y las demás leyes y ordenamientos aplicables, regulan la entrada al territorio nacional y la salida del mismo de mercancías...</p>
        
        <h4 id="tit-2">TÍTULO SEGUNDO - Control de la Aduana en el Despacho</h4>
        <p><strong>ARTÍCULO 10.</strong> La entrada y salida de mercancías del territorio nacional, las maniobras de carga, descarga, transbordo y almacenamiento de las mismas...</p>
      </div>
    `
  },
  {
    id: 'reglamento-ley-aduanera',
    titulo: 'Reglamento de la Ley Aduanera',
    descripcion: 'Disposiciones reglamentarias de la Ley Aduanera.',
    tipo: 'REGLAMENTO',
    actualizado: '2015',
    categoria: 'comercio_exterior',
    contenido: '<p>Contenido del Reglamento de la Ley Aduanera...</p>'
  },
  {
    id: 'ley-comercio-exterior',
    titulo: 'Ley de Comercio Exterior',
    descripcion: 'Regula el comercio exterior, la economía del país y la competitividad.',
    tipo: 'LEY',
    actualizado: '2023',
    categoria: 'comercio_exterior',
    contenido: '<p>Objeto de la ley: Regular y promover el comercio exterior...</p>'
  },
  {
    id: 'reg-lce',
    titulo: 'Reglamento de la Ley de Comercio Exterior',
    descripcion: 'Detalles operativos de la LCE.',
    tipo: 'REGLAMENTO',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Contenido del Reglamento...</p>'
  },

  // --- LEYES FISCALES ---
  {
    id: 'cff',
    titulo: 'Código Fiscal de la Federación',
    descripcion: 'Ordenamiento jurídico tributario federal.',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Disposiciones generales del Código Fiscal...</p>'
  },
  {
    id: 'reg-cff',
    titulo: 'Reglamento del CFF',
    descripcion: 'Reglamento del Código Fiscal de la Federación.',
    tipo: 'REGLAMENTO',
    actualizado: '2014',
    categoria: 'fiscal',
    contenido: '<p>Reglamento...</p>'
  },
  {
    id: 'ley-iva',
    titulo: 'Ley del Impuesto al Valor Agregado',
    descripcion: 'Regula el IVA en importaciones y en territorio nacional.',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Art. 1o.- Están obligadas al pago del impuesto...</p>'
  },
  {
    id: 'ley-isr',
    titulo: 'Ley del Impuesto Sobre la Renta',
    descripcion: 'Regula el ISR para personas físicas y morales.',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Disposiciones del ISR...</p>'
  },
  {
    id: 'ley-ieps',
    titulo: 'Ley del IEPS',
    descripcion: 'Impuesto Especial sobre Producción y Servicios.',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Impuestos especiales...</p>'
  },
  {
    id: 'lfd',
    titulo: 'Ley Federal de Derechos',
    descripcion: 'Establece el pago de derechos por servicios públicos (DTA).',
    tipo: 'LEY',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Artículo 49. Se pagará el derecho de trámite aduanero...</p>'
  },

  // --- REGLAS Y RESOLUCIONES ---
  {
    id: 'rgce-2024',
    titulo: 'Reglas Generales de Comercio Exterior 2024',
    descripcion: 'Reglas administrativas emitidas por el SAT.',
    tipo: 'REGLA',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Reglas Generales de Comercio Exterior vigentes...</p>'
  },
  {
    id: 'anexo-22',
    titulo: 'Anexo 22 de las RGCE',
    descripcion: 'Instructivo para el llenado del Pedimento.',
    tipo: 'REGLA',
    actualizado: '2024',
    categoria: 'comercio_exterior',
    contenido: '<p>Apéndices y claves del pedimento...</p>'
  },
  {
    id: 'rmf-2024',
    titulo: 'Resolución Miscelánea Fiscal 2024',
    descripcion: 'Reglas de carácter general en materia de impuestos internos.',
    tipo: 'REGLA',
    actualizado: '2024',
    categoria: 'fiscal',
    contenido: '<p>Contenido de la RMF...</p>'
  },

  // --- TARIFA ---
  {
    id: 'ligie',
    titulo: 'LIGIE (Ley de los Impuestos Generales)',
    descripcion: 'Tarifa arancelaria actualizada (TIGIE 2022).',
    tipo: 'TIGIE',
    actualizado: '2022',
    categoria: 'clasificacion',
    contenido: '<p>Art. 1o. Tarifa...</p>'
  },
  {
    id: 'nico',
    titulo: 'Números de Identificación Comercial (NICO)',
    descripcion: 'Acuerdo por el que se dan a conocer los NICO.',
    tipo: 'ACUERDO',
    actualizado: 'Vigente',
    categoria: 'clasificacion',
    contenido: '<p>Listado de NICOs...</p>'
  },
  {
    id: 'notas-explicativas',
    titulo: 'Notas Explicativas del Sistema Armonizado',
    descripcion: 'Notas para la interpretación de la TIGIE.',
    tipo: 'GUIA',
    actualizado: 'Vigente',
    categoria: 'clasificacion',
    contenido: '<p>Notas de Capítulo, Partida...</p>'
  },

  // --- TRATADOS INTERNACIONALES ---
  {
    id: 'tmec',
    titulo: 'T-MEC (México, Estados Unidos, Canadá)',
    descripcion: 'Tratado comercial entre los países de Norteamérica.',
    tipo: 'TRATADO',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Texto completo del T-MEC...</p>'
  },
  {
    id: 'tmec-reglamentaciones',
    titulo: 'Reglamentaciones Uniformes T-MEC',
    descripcion: 'Reglas para la aplicación e interpretación del T-MEC.',
    tipo: 'TRATADO',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Reglamentaciones...</p>'
  },
  {
    id: 'tlcuem',
    titulo: 'TLCUEM (Unión Europea)',
    descripcion: 'Tratado de Libre Comercio con la Unión Europea.',
    tipo: 'TRATADO',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Texto del tratado...</p>'
  },
  {
    id: 'tipat',
    titulo: 'TIPAT / CPTPP',
    descripcion: 'Tratado Integral y Progresista de Asociación Transpacífico.',
    tipo: 'TRATADO',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Texto del TIPAT...</p>'
  },

  // --- DECRETOS Y FOMENTO ---
  {
    id: 'decreto-immex',
    titulo: 'Decreto IMMEX',
    descripcion: 'Fomento de la Industria Manufacturera, Maquiladora y de Servicios de Exportación.',
    tipo: 'DECRETO',
    actualizado: 'Reformado',
    categoria: 'comercio_exterior',
    contenido: '<p>Beneficios del programa IMMEX...</p>'
  },
  {
    id: 'decreto-prosec',
    titulo: 'Decreto PROSEC',
    descripcion: 'Programas de Promoción Sectorial.',
    tipo: 'DECRETO',
    actualizado: 'Reformado',
    categoria: 'comercio_exterior',
    contenido: '<p>Sectores beneficiados...</p>'
  },

  // --- NOMS ---
  {
    id: 'nom-050',
    titulo: 'NOM-050-SCFI-2004',
    descripcion: 'Información comercial - Etiquetado general de productos.',
    tipo: 'NOM',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Requisitos de etiquetado...</p>'
  },
  {
    id: 'nom-051',
    titulo: 'NOM-051-SCFI/SSA1-2010',
    descripcion: 'Etiquetado para alimentos y bebidas no alcohólicas (Sellos).',
    tipo: 'NOM',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Especificaciones de etiquetado frontal...</p>'
  },

  // --- MANUALES ---
  {
    id: 'moa',
    titulo: 'Manual de Operación Aduanera (MOA)',
    descripcion: 'Procesos y procedimientos de la operación aduanera.',
    tipo: 'MANUAL',
    actualizado: 'Vigente',
    categoria: 'comercio_exterior',
    contenido: '<p>Diagramas de flujo y procedimientos...</p>'
  },

  // --- PLACEHOLDERS PARA COMPLETAR LA NAVEGACIÓN ---
  { id: 'rgce-2023', titulo: 'RGCE 2023 (Histórico)', descripcion: 'Reglas anteriores.', tipo: 'REGLA', actualizado: '2023', categoria: 'comercio_exterior' },
  { id: 'rgce-2022', titulo: 'RGCE 2022 (Histórico)', descripcion: 'Reglas anteriores.', tipo: 'REGLA', actualizado: '2022', categoria: 'comercio_exterior' },
  { id: 'tlc-aelc', titulo: 'TLC México-AELC', descripcion: 'Tratado con la Asociación Europea de Libre Comercio.', tipo: 'TRATADO', actualizado: 'Vigente', categoria: 'comercio_exterior' },
  { id: 'alianza-pacifico', titulo: 'Alianza del Pacífico', descripcion: 'Acuerdo marco de la Alianza.', tipo: 'TRATADO', actualizado: 'Vigente', categoria: 'comercio_exterior' },
  { id: 'tlc-centroamerica', titulo: 'TLC México-Centroamérica', descripcion: 'Tratado único con la región.', tipo: 'TRATADO', actualizado: 'Vigente', categoria: 'comercio_exterior' },
  { id: 'decreto-drawback', titulo: 'Decreto de Devolución de Impuestos (Drawback)', descripcion: 'Esquema de devolución.', tipo: 'DECRETO', actualizado: 'Vigente', categoria: 'comercio_exterior' },
  { id: 'decreto-franja', titulo: 'Decreto de la Franja Fronteriza Norte', descripcion: 'Estímulos fiscales.', tipo: 'DECRETO', actualizado: 'Vigente', categoria: 'fiscal' },
  { id: 'decreto-chetumal', titulo: 'Decreto de Zona Libre de Chetumal', descripcion: 'Estímulos fiscales locales.', tipo: 'DECRETO', actualizado: 'Vigente', categoria: 'fiscal' },
  { id: 'nom-024', titulo: 'NOM-024-SCFI-2013', descripcion: 'Información comercial para empaques.', tipo: 'NOM', actualizado: 'Vigente', categoria: 'comercio_exterior' },
  { id: 'nom-001', titulo: 'NOM-001-SCFI-2018', descripcion: 'Aparatos electrónicos - Seguridad.', tipo: 'NOM', actualizado: 'Vigente', categoria: 'seguridad' }
]

// --- ESTRUCTURA DE NAVEGACIÓN (JERARQUÍA) ---

export const ESTRUCTURA_LEGAL: CategoriaNavegacion[] = [
  {
    id: 'leyes',
    titulo: 'Leyes y Códigos',
    icono: ScaleIcon,
    grupos: [
      {
        titulo: 'Marco Constitucional',
        items: [
          { titulo: 'Constitución (CPEUM)', tipo: 'DOC', id_doc: 'cpeum', etiqueta: 'Suprema' }
        ]
      },
      {
        titulo: 'Legislación Aduanera',
        items: [
          { titulo: 'Ley Aduanera', tipo: 'DOC', id_doc: 'ley-aduanera', etiqueta: 'Vigente' },
          { titulo: 'Reglamento LA', tipo: 'DOC', id_doc: 'reglamento-ley-aduanera' },
          { titulo: 'Ley de Comercio Exterior', tipo: 'DOC', id_doc: 'ley-comercio-exterior' },
          { titulo: 'Reglamento LCE', tipo: 'DOC', id_doc: 'reg-lce' }
        ]
      },
      {
        titulo: 'Legislación Fiscal Federal',
        items: [
          { titulo: 'Código Fiscal (CFF)', tipo: 'DOC', id_doc: 'cff' },
          { titulo: 'Reglamento CFF', tipo: 'DOC', id_doc: 'reg-cff' },
          { titulo: 'Ley del IVA', tipo: 'DOC', id_doc: 'ley-iva' },
          { titulo: 'Ley del ISR', tipo: 'DOC', id_doc: 'ley-isr' },
          { titulo: 'Ley del IEPS', tipo: 'DOC', id_doc: 'ley-ieps' },
          { titulo: 'Ley Federal de Derechos', tipo: 'DOC', id_doc: 'lfd' }
        ]
      }
    ]
  },
  {
    id: 'reglas',
    titulo: 'Reglas y Criterios',
    icono: ShieldCheckIcon,
    grupos: [
      {
        titulo: 'Reglas Generales (RGCE)',
        items: [
          { titulo: 'RGCE 2024', tipo: 'DOC', id_doc: 'rgce-2024', etiqueta: 'Actual' },
          { titulo: 'Anexo 22 (Instructivo)', tipo: 'DOC', id_doc: 'anexo-22' },
          { titulo: 'Histórico RGCE', tipo: 'GRUPO', subItems: [
             { titulo: 'RGCE 2023', tipo: 'DOC', id_doc: 'rgce-2023' },
             { titulo: 'RGCE 2022', tipo: 'DOC', id_doc: 'rgce-2022' }
          ]}
        ]
      },
      {
        titulo: 'Resolución Miscelánea',
        items: [
          { titulo: 'RMF 2024', tipo: 'DOC', id_doc: 'rmf-2024' }
        ]
      }
    ]
  },
  {
    id: 'tratados',
    titulo: 'Tratados (TLCs)',
    icono: GlobeAmericasIcon,
    grupos: [
      {
        titulo: 'Norteamérica',
        items: [
          { titulo: 'T-MEC', tipo: 'DOC', id_doc: 'tmec', etiqueta: 'Clave' },
          { titulo: 'Reglamentaciones T-MEC', tipo: 'DOC', id_doc: 'tmec-reglamentaciones' }
        ]
      },
      {
        titulo: 'Europa y Asia',
        items: [
          { titulo: 'TLCUEM (Unión Europea)', tipo: 'DOC', id_doc: 'tlcuem' },
          { titulo: 'TIPAT (Transpacífico)', tipo: 'DOC', id_doc: 'tipat' },
          { titulo: 'TLC-AELC', tipo: 'DOC', id_doc: 'tlc-aelc' }
        ]
      },
      {
        titulo: 'Latinoamérica',
        items: [
          { titulo: 'Alianza del Pacífico', tipo: 'DOC', id_doc: 'alianza-pacifico' },
          { titulo: 'TLC México-Centroamérica', tipo: 'DOC', id_doc: 'tlc-centroamerica' }
        ]
      }
    ]
  },
  {
    id: 'decretos',
    titulo: 'Decretos y Fomento',
    icono: BuildingOfficeIcon,
    grupos: [
      {
        titulo: 'Programas de Fomento',
        items: [
          { titulo: 'Decreto IMMEX', tipo: 'DOC', id_doc: 'decreto-immex' },
          { titulo: 'Decreto PROSEC', tipo: 'DOC', id_doc: 'decreto-prosec' },
          { titulo: 'Decreto Drawback', tipo: 'DOC', id_doc: 'decreto-drawback' }
        ]
      },
      {
        titulo: 'Estímulos Fiscales',
        items: [
          { titulo: 'Decreto Franja Fronteriza', tipo: 'DOC', id_doc: 'decreto-franja' },
          { titulo: 'Decreto Chetumal', tipo: 'DOC', id_doc: 'decreto-chetumal' }
        ]
      }
    ]
  },
  {
    id: 'noms',
    titulo: 'NOMs',
    icono: TagIcon,
    grupos: [
      {
        titulo: 'Información Comercial',
        items: [
          { titulo: 'NOM-050 (General)', tipo: 'DOC', id_doc: 'nom-050' },
          { titulo: 'NOM-051 (Alimentos)', tipo: 'DOC', id_doc: 'nom-051' },
          { titulo: 'NOM-024 (Electrónicos)', tipo: 'DOC', id_doc: 'nom-024' }
        ]
      },
      {
        titulo: 'Seguridad',
        items: [
          { titulo: 'NOM-001 (Electrónicos)', tipo: 'DOC', id_doc: 'nom-001' }
        ]
      }
    ]
  },
  {
    id: 'tarifa',
    titulo: 'Tarifa y Clasificación',
    icono: CurrencyDollarIcon,
    grupos: [
      {
        titulo: 'LIGIE 2022',
        items: [
          { titulo: 'Ley (LIGIE)', tipo: 'DOC', id_doc: 'ligie' },
          { titulo: 'NICO', tipo: 'DOC', id_doc: 'nico' },
          { titulo: 'Notas Explicativas', tipo: 'DOC', id_doc: 'notas-explicativas' }
        ]
      }
    ]
  },
  {
    id: 'manuales',
    titulo: 'Manuales',
    icono: BookOpenIcon,
    grupos: [
      {
        titulo: 'Operativos',
        items: [
          { titulo: 'Manual de Operación Aduanera (MOA)', tipo: 'DOC', id_doc: 'moa' }
        ]
      }
    ]
  }
]
